export enum ListingRequestType {
  Create = 'created',
  Edit = 'updated',
  Relist = 'relisted'
}
